import { render, staticRenderFns } from "./grabCoupon.vue?vue&type=template&id=855e4e9a&scoped=true&"
import script from "./grabCoupon.vue?vue&type=script&lang=ts&"
export * from "./grabCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./grabCoupon.vue?vue&type=style&index=0&id=855e4e9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855e4e9a",
  null
  
)

export default component.exports